import React from 'react';

// Class-компонент без хуков: язык читаем напрямую, словарь локальный.
const EB_STR = {
  ru: { eb_title: 'Что-то пошло не так', eb_hint: 'Эта вкладка не загрузилась. Остальное приложение работает.', eb_retry: 'Попробовать снова', eb_reload: 'Перезагрузить страницу' },
  en: { eb_title: 'Something went wrong', eb_hint: 'This tab failed to load. The rest of the app still works.', eb_retry: 'Try again', eb_reload: 'Reload the page' },
  es: { eb_title: 'Algo salió mal', eb_hint: 'Esta pestaña no cargó. El resto de la app funciona.', eb_retry: 'Reintentar', eb_reload: 'Recargar la página' },
  ar: { eb_title: 'حدث خطأ ما', eb_hint: 'تعذر تحميل هذا التبويب. بقية التطبيق تعمل.', eb_retry: 'حاول مجدداً', eb_reload: 'أعد تحميل الصفحة' },
  de: { eb_title: 'Etwas ist schiefgelaufen', eb_hint: 'Dieser Tab konnte nicht geladen werden. Der Rest funktioniert.', eb_retry: 'Erneut versuchen', eb_reload: 'Seite neu laden' },
};
const EB = (k) => { let l = 'ru'; try { l = localStorage.getItem('ui_lang') || 'ru'; } catch { /* ignore */ } return (EB_STR[l] || EB_STR.ru)[k] || EB_STR.ru[k]; };
import { clearCache } from '../hooks/useResource.js';

// Catches render errors in the wrapped subtree so one broken tab can't take down
// the whole app (header/nav and other tabs keep working).
//  • Resets automatically when `resetKey` changes (e.g. on tab switch).
//  • "Try again" does a soft recovery: clears cached data and remounts the
//    subtree (via the nonce key) — no full page reload, state elsewhere is kept.
//  • "Reload page" is the hard fallback.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, nonce: 0 };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('Tab crashed:', error, info);
  }
  componentDidUpdate(prevProps) {
    // when the active tab changes, clear the error so the new tab can render
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }
  retry = () => {
    try { clearCache(); } catch { /* noop */ }
    this.setState((s) => ({ hasError: false, nonce: s.nonce + 1 }));
  };
  render() {
    if (this.state.hasError) {
      const btn = {
        padding: '10px 20px', borderRadius: 9, cursor: 'pointer',
        fontSize: 13, fontWeight: 600,
      };
      return (
        <div style={{ padding: 40, textAlign: 'center', color: 'var(--app-text,#ece6d6)' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>😵</div>
          <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>
            {this.props.label || EB('eb_title')}
          </div>
          <div style={{ fontSize: 13, color: '#8a8a92', marginBottom: 20, lineHeight: 1.6 }}>
            {this.props.hint || EB('eb_hint')}
          </div>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button onClick={this.retry}
              style={{ ...btn, background: 'var(--app-accent-grad,linear-gradient(135deg,#e8cf8a,#c9a24b))', border: 'none', color: '#0d0d10' }}>
              {this.props.retryLabel || EB('eb_retry')}
            </button>
            <button onClick={() => window.location.reload()}
              style={{ ...btn, background: 'transparent', border: '1px solid #ffffff33', color: 'var(--app-text,#ece6d6)' }}>
              {this.props.reloadLabel || EB('eb_reload')}
            </button>
          </div>
        </div>
      );
    }
    // keyed wrapper lets "Try again" force a clean remount without affecting layout
    return <div style={{ display: 'contents' }} key={this.state.nonce}>{this.props.children}</div>;
  }
}
